module.exports = __webpack_public_path__ + "static/media/time-budget.2013caad.svg";